/** @format */

const common = {
    // Authentication page
    auth_logo: "/assets/images/png/common/Logo-white.png",
    auth_form_earth: "/assets/images/png/common/earth.png",
    auth_slider_step2_logo: "/assets/images/png/common/key_logo.png",
    background_pattern: "/assets/images/png/Pattern-login-new.png",

    // Form helper background
    form_default_background: "/assets/images/svg/tms/tms_tab_projet_forumlaire_candidature.svg",

    // Default logo
    app_logo: "/assets/images/svg/Logo-white.svg",
    app_logo_mobile: "/assets/images/svg/Logo-black.svg",
    key_player_logo: "/assets/images/svg/Logo-white.svg",
    Logo_white: "/assets/images/svg/Logo-white.svg",
    Logo_black: "/assets/images/svg/Logo-black.svg",
    Favicon_white: "/assets/images/svg/Favicon-white.svg",
    Favicon_black: "/assets/images/svg/Favicon-black.svg",
    ct_logo: "/assets/images/svg/CentralTest_Logo_RVB_2020.svg",

    // Loader
    loader: "/assets/images/gif/common/keypredict_loader_mono_hd.gif",

    // Misc
    left_image: "/assets/images/png/common/left_image.png",
    more_star: "/assets/images/svg/common/more-star.svg",
    list: "/assets/images/svg/common/list.svg",
    email: "/assets/images/svg/common/email.svg",
    ellipse6: "/assets/images/svg/common/ellipse-6.svg",
    city_image: "/assets/images/svg/common/city-image.svg",
    load_icon: "/assets/images/svg/common/load-icon.svg",
    all_name: "/assets/images/svg/common/all-name.svg",
    sort_custom: "/assets/images/svg/common/sort-custom.svg",
    send_icon: "/assets/images/svg/common/send-icon.svg",
    check_icon: "/assets/images/svg/common/check-icon.svg",
    check_icon_green: "/assets/images/svg/common/check-icon-green.svg",
    arrow_left: "/assets/images/svg/common/arrow-left.svg",
    city_building: "/assets/images/svg/common/city_building.svg",
    project_placeholder: "/assets/images/svg/common/project-empty-selected-placeholder.svg",
    profile_user: "/assets/images/svg/common/profile-user.svg",
    questionnaire_icon: "/assets/images/svg/common/questionnaire_icon.svg",
    translation_icon: "/assets/images/svg/common/translation_icon.svg",
    timer_icon: "/assets/images/svg/common/timer_icon.svg",
    contact_icon: "/assets/images/svg/common/contact_icon.svg",
    bell_silence: "/assets/images/svg/common/bell_silence.svg",
    reporting_hight: "/assets/images/svg/common/reporting_hight.svg",
    reporting_medium: "/assets/images/svg/common/reporting_medium.svg",
    reporting_low: "/assets/images/svg/common/reporting_low.svg",
    person: "/assets/images/svg/common/person.svg",
    favorites: "/assets/images/svg/common/favorites.svg",
    green_leaf: "/assets/images/svg/common/green_leaf.svg",
    mapview: "/assets/images/svg/common/mapview.svg",
    listview: "/assets/images/svg/common/listview.svg",
    sent_blue: "/assets/images/svg/common/sent_blue.svg",
    link_outline: "/assets/images/svg/common/link_outline.svg",
    report: "/assets/images/svg/common/report.svg",
    generic_city: "/assets/images/svg/common/228_city_buildings_flatline.svg",
    empty: '/assets/images/svg/common/empty_box.svg',
    alert_icon: '/assets/images/svg/common/alert-icon.svg',
    info_icon: '/assets/images/svg/common/info-icon.svg',

    // Smiley
    happy_smiley: "/assets/images/svg/common/Happy_face_Two_Color.svg",
    smile_smiley: "/assets/images/svg/common/Smiley_face_Two_Color.svg",
    sad_smiley: "/assets/images/svg/common/Sad_face_Two_Color.svg",
    neutral_smiley: "/assets/images/svg/common/Neutral_face_Two_Color.svg",
    upload_folder: "/assets/images/svg/common/Upload_folder.svg",
    csv: "/assets/images/svg/common/CSV.svg"
}

export default common
